import InputEntryDialog from "./InputEntryDialog"

export default InputEntryDialog;